/**
 * bookingOrigin — origen de la reserva (Bloque 3): el link/QR abre `/r/:usuario?s=qr_print|qr_screen|link`.
 * Se guarda en sessionStorage para sobrevivir a los pasos del flujo y al login; caduca a las 2 h.
 */
const KEY = 'lbw_booking_origin';
const TTL_MS = 2 * 60 * 60 * 1000;
export const ORIGINS = ['qr_print', 'qr_screen', 'link', 'app'];

export const captureOrigin = (searchParams) => {
  const s = searchParams?.get?.('s');
  if (!s || !ORIGINS.includes(s) || s === 'app') return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ s, at: Date.now() })); } catch { /* storage bloqueado */ }
};

export const currentOrigin = () => {
  try {
    const raw = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (raw?.s && ORIGINS.includes(raw.s) && Date.now() - (raw.at || 0) < TTL_MS) return raw.s;
  } catch { /* noop */ }
  return 'app';
};

export const clearOrigin = () => { try { sessionStorage.removeItem(KEY); } catch { /* noop */ } };

/** URL pública de reserva (corta) de un barbero o barbería. */
export const bookingLink = (username, origin = 'link') => {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/r/${encodeURIComponent(username || '')}${origin && origin !== 'app' ? `?s=${origin}` : ''}`;
};
